import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Paths } from "../constants/enums";
import { useAuth } from "../contexts/AuthContext";
import { getDashboardPathForRole } from "../utils/tokenUtils";

const RedirectToRoleDashboard = () => {
  const { user } = useAuth();
  const [redirectPath, setRedirectPath] = useState(Paths.ROOT);

  useEffect(() => {
    if (user?.role) {
      const path = getDashboardPathForRole(user.role);
      setRedirectPath(path);
    }
  }, [user]);

  return <Navigate to={redirectPath} replace />;
};

export default RedirectToRoleDashboard;
